import { render, staticRenderFns } from "./SolutionsFeatures.vue?vue&type=template&id=0b9d9c6e&scoped=true"
import script from "./SolutionsFeatures.js?vue&type=script&lang=js&external"
export * from "./SolutionsFeatures.js?vue&type=script&lang=js&external"
import style0 from "./SolutionsFeatures.scss?vue&type=style&index=0&id=0b9d9c6e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d9c6e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
